export const termsTranslations = {
  title: "Terms and Conditions of Sale and Use (TCSU)",
  description: "Terms and conditions of sale and use for Leadsme. Access, usage and subscription terms for the offers provided.",
  content: `1. Object
These Terms and Conditions of Sale and Use (hereinafter "TCSU") aim to define the conditions under which the publisher makes the Leadsme service available, as well as the terms of access, use, and, where applicable, subscription to the offers provided.
The Leadsme service is an online management and organization tool intended for content creators and related professionals, including features for contact management, projects, files, and informative payment tracking.

2. Acceptance of TCSU
Access to and use of the service implies full and complete acceptance of these TCSU.
This acceptance is materialized:
- either when creating an account,
- or by actual use of the service.
The TCSU constitute a contract binding the user and the publisher.

3. Service Access
The service is accessible via a personal user account.
The publisher implements reasonable means to ensure service accessibility, without guaranteeing continuous or interruption-free availability.
Temporary suspensions may occur, in particular for maintenance, updates, technical incidents, or external constraints.
The service is primarily intended for users established in France, for professional use, and assumes the legal capacity to contract.

4. Account Creation and Authentication
Creating an account requires providing accurate, complete, and up-to-date information.
The user is solely responsible for:
- the information provided,
- the confidentiality of their credentials,
- any use of the service made via their account.
The account is strictly personal and non-transferable. Any sharing or unauthorized use is prohibited.
The publisher cannot be held responsible for unauthorized access resulting from user negligence.

5. Service Description
Leadsme offers the following features, in particular:
- user account management,
- contact and prospect management,
- project and deliverable management,
- file upload related to projects,
- informative payment tracking tool,
- subscription management,
- transactional email sending,
- support via contact form or email.
The service may evolve at any time. The publisher reserves the right to modify, add, or remove certain features, without obligation to maintain the service identically.

6. Service Use
The user undertakes to use the service:
- in a lawful professional context,
- in accordance with applicable laws and regulations,
- in accordance with the service's purpose.
The user remains solely responsible for:
- the data they enter,
- the content they host,
- decisions made based on information provided by the service.
The service does not guarantee commercial results, performance, or accuracy or relevance of processed data.
The service may include management assistance tools, in particular a payment tracking tool, provided strictly for informational purposes and based on information entered by the user.
These tools are neither accounting, tax, nor legal tools, and in no way replace the user's legal obligations.

7. Hosted Files and Content
The user may upload files related to their projects (e.g., briefs, quotes, invoices, deliverables).
The user guarantees having all necessary rights to uploaded files.
The publisher:
- exercises no prior control over content,
- is not responsible for content hosted by users.
The service is not intended to constitute a long-term storage or archiving solution. It is the user's responsibility to keep their own copies of files.

8. Subscriptions, Offers, and Payments
Access to certain service features may require subscription to a paid subscription.
A free version and a free trial of certain offers may be provided according to the terms indicated on the website.
The free trial is for a period of fourteen (14) days and is limited to a single use per user.
The user undertakes to respect the quotas, limits, and conditions applicable to the subscribed offer or plan, as defined on the website or in the service.
Subscriptions are automatically renewed according to the chosen periodicity, unless terminated by the user.
Payments related to subscriptions are processed exclusively by a third-party payment provider. The publisher never has access to users' banking data.
The publisher reserves the right to modify subscription prices.
Any price modification is brought to the user's attention before it takes effect and applies to subsequent subscription periods.
The user retains the option to cancel their subscription before the application of new prices.

9. Termination
The user may terminate their subscription at any time according to the terms available in their user area or via management tools provided by the payment provider.
The publisher reserves the right to suspend or terminate an account, without compensation, in case of:
- non-compliance with TCSU,
- abusive or unlawful use of the service,
- breach of service security or integrity.
In case of serious breach, termination may occur without notice.

10. Data Deletion
In case of termination or upon user request, data may be deleted by the publisher within a reasonable period, subject to applicable legal or technical obligations.
Deletion of certain data may require a request to support.

11. Support
Support is provided via contact form or email. The user undertakes to use support reasonably and non-abusively.
Response times may vary. No service level (SLA) is guaranteed.

12. Security
The publisher implements reasonable security measures to protect the service and data. The user undertakes not to compromise service security.
No guarantee of absolute security is provided.

13. Liability
The publisher cannot be held responsible for:
- indirect damages,
- data losses attributable to the user,
- consequences related to service use.
The publisher's liability is limited to proven direct damages, within the limits provided by law.

14. Intellectual Property
The service, its elements, interfaces, trademarks, and content are protected by intellectual property law.
Any unauthorized reproduction, exploitation, or use is prohibited.

15. Personal Data
Personal data processing is described in the privacy policy accessible on the website.

16. Service Evolution and Shutdown
The publisher reserves the right to evolve or stop the service, subject to reasonable notice.
In case of permanent service shutdown, ongoing annual subscriptions may be refunded pro-rata for the unused period.

17. Transfer
In case of transfer, transmission, or acquisition of the service, these TCSU will remain applicable, subject to user notification.

18. TCSU Modification
The publisher reserves the right to modify the TCSU at any time. New versions apply as soon as they are published online.
Continued use of the service implies acceptance of the modified TCSU.

19. Applicable Law and Competent Jurisdiction
These TCSU are governed by French law.
Any dispute will fall under the jurisdiction of French courts.`,
  lastUpdate: "January 9, 2026",
} as const;